module.exports = __webpack_public_path__ + "img/colorBox5.c1153a52.jpg";